import { render, staticRenderFns } from "./OrderGroupingHistory.vue?vue&type=template&id=4b390382&scoped=true&"
import script from "./OrderGroupingHistory.vue?vue&type=script&lang=js&"
export * from "./OrderGroupingHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrderGroupingHistory.vue?vue&type=style&index=0&id=4b390382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b390382",
  null
  
)

export default component.exports